import { FC } from "react"
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import { Icon, IconColor } from "@/components/shared/Icon"
import { ColorVariant } from "@/types/index"
import "./index.scss"

export interface WearableIneligibleProps {
   onBack?: () => void
   onManualSelection?: () => void
}

const WearableIneligible: FC<WearableIneligibleProps> = ({
   onBack,
   onManualSelection,
}) => {
   return (
      <div className="wearable-ineligible">
         <div className="wearable-ineligible__header">
            <Icon
               name="scanWearable"
               size="40"
               color={IconColor.HONOLULU_BLUE}
            />
            <div className="wearable-ineligible__title">
               Scan another ReassureBand to continue
            </div>
         </div>
         <div className="wearable-ineligible__actions">
            {onManualSelection && onBack && (
               <Button
                  color={ColorVariant.HONOLULU_BLUE}
                  className="wearable-ineligible__button"
                  iconPosition={ButtonIconPosition.LEFT}
                  onClick={onBack}
                  iconName="arrowLeft"
               >
                  Back
               </Button>
            )}
            {onManualSelection && (
               <Button
                  color={ColorVariant.HONOLULU_BLUE}
                  className="wearable-ineligible__button"
                  onClick={onManualSelection}
               >
                  Manual selection
               </Button>
            )}
         </div>
      </div>
   )
}

export default WearableIneligible
